import angular from 'angular';
import constants from '../constants';
import './'
import apiService from './APIService';
import appCache from './ApplicationCache';
import dataSyncServiceModule from './DataSyncService';
import incrementalDataStoreModule from './IncrementalDataStore';
import incrementalDataStoreServiceModule from './IncrementalDataStoreService';
import logServiceModule from './LogService';
import translationModuleName from '../translation';
import translationServiceModule from './TranslationService';
import dateTimeService from './DateTimeService';
import positionSearchServiceModule from './PositionSearchService';
import filters from '../filters';

import documentResizeServiceModule from './DocumentResizeService';


import ngFileUpload from 'ng-file-upload';
import 'angular-dynamic-locale';

const MODULE_NAME = 'recaps.services';

let m = angular.module(MODULE_NAME, [
  constants,
  ngFileUpload,
  'tmh.dynamicLocale',
  'ngLocale',
  apiService.name,
  appCache.name,
  dataSyncServiceModule.name,
  incrementalDataStoreModule.name,
  incrementalDataStoreServiceModule.name,
  logServiceModule.name,
  translationModuleName,
  translationServiceModule.name,
  dateTimeService.name,
  positionSearchServiceModule.name,
  filters.name,
  documentResizeServiceModule.name,
]);

export default m;
